module.exports = __webpack_public_path__ + "static/media/star-icon.3623387d.svg";